import { render, staticRenderFns } from "./CalculationButton.vue?vue&type=template&id=5f4a0c4c&scoped=true&"
import script from "./CalculationButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalculationButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CalculationButton.vue?vue&type=style&index=0&id=5f4a0c4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a0c4c",
  null
  
)

export default component.exports